import { render, staticRenderFns } from "./BlocksMenu.vue?vue&type=template&id=13212fba"
import script from "./BlocksMenu.vue?vue&type=script&lang=js"
export * from "./BlocksMenu.vue?vue&type=script&lang=js"
import style0 from "./BlocksMenu.vue?vue&type=style&index=0&id=13212fba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports